var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"webpack": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"css-icons_LoadingImg_css-app_lang_desktop_app_create_Create_module_css-app_lang_desktop_app_p-5ef452":1,"css-app_globals_css":1,"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-c367a1":1,"css-components-mobile_HomeFilter_style_module_css":1,"css-components_chat-dom_styles_chat_css":1,"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-26e88c":1,"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-88f67e":1,"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-497c06":1,"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-0ce01c":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr